<template>
    <div>
        <div v-if="this.inscription" class="row">
            <div class="col-md-12">
                <div class="box box-primary">
                    <div class="box-header with-border">
                        <h3 class="box-title">Inscription et résultat</h3>
                        <button type="button"
                                class="btn btn-xs btn-default btn-flat margin pull-right"
                                style="margin-top: 0;margin-bottom: 0;"
                                @click="resetInscription()"
                        >
                            Réinitialiser le formulaire
                        </button>
                    </div>
                    <div class="box-body">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group"
                                             :class="{'has-error': errors.has('inscription[idMembre]') }">
                                            <label for="searchmember">Recherche du membre</label>
                                            <v-select v-model="inscription.idMembre"
                                                      label="fullName"
                                                      :filterable="false"
                                                      :taggable="false"
                                                      :debounce="250"
                                                      :on-search="SearchMembersResponse"
                                                      :options="ArrayMembersSearch">
                                            <span slot="selected-option" slot-scope="props">
                                                <router-link :to="{ name: 'Member', params: { member_id: props.selectedOption.id }}">
                                                    {{ props.selectedOption.fullName}}
                                                </router-link>
                                            </span>
                                                <template slot="option" slot-scope="props">
                                                    <span :class="props.item.licencie? 'text-green' : 'text-red'">{{props.item.fullName +" - "+props.item.club.club}}</span>
                                                </template>
                                            </v-select>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-3">
                                        <label for="">Inscription</label>
                                        <div class="form-group">
                                            <label class="radio-inline">
                                                <input type="radio" name="inscription[inscription]" id="radioMasculin"
                                                       value="1"
                                                       v-model="inscription.inscription">
                                                Oui
                                            </label>
                                            <label class="radio-inline">
                                                <input type="radio" name="inscription[inscription]" id="radioFeminin"
                                                       value="0"
                                                       v-model="inscription.inscription"
                                                >
                                                Non
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Du:</label>
                                            <div class="input-group date ">
                                                <div class="input-group-addon">
                                                    <i class="fa fa-calendar"></i>
                                                </div>
                                                <input type="text" name="periodeDu" v-model="inscription.dateInscription"
                                                       class="form-control pull-right datepicker" id="datepicker1">
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-3">
                                        <label for="">Payement</label>
                                        <div class="form-group">
                                            <label class="radio-inline">
                                                <input type="radio" name="inscription[payement]" id="radiopayement"
                                                       value="1"
                                                       v-model="inscription.payement">
                                                Oui
                                            </label>
                                            <label class="radio-inline">
                                                <input type="radio" name="inscription[payement]" id="radiopayement2"
                                                       value="0"
                                                       v-model="inscription.payement"
                                                >
                                                Non
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Du:</label>
                                            <div class="input-group date ">
                                                <div class="input-group-addon">
                                                    <i class="fa fa-calendar"></i>
                                                </div>
                                                <input type="text" name="periodeDu" v-model="inscription.datePayement"
                                                       class="form-control pull-right datepicker" id="datepicker2">
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-3">
                                        <label for="">Réussite</label>
                                        <div class="form-group">
                                            <label class="radio-inline">
                                                <input type="radio" name="inscription[reussite]" id="radioReussite"
                                                       value="1"
                                                       v-model="inscription.reussite">
                                                Oui
                                            </label>
                                            <label class="radio-inline">
                                                <input type="radio" name="inscription[reussite]" id="radioReussite2"
                                                       value="0"
                                                       v-model="inscription.reussite"
                                                >
                                                Non
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group"
                                             :class="{'has-error': errors.has('inscription[comments]') }">
                                            <label for="adresse">Commentaires</label>
                                            <textarea type="text" class="form-control" id="comments" name="inscription[comments]"
                                                      placeholder="Commentaires éventuels"
                                                      v-model="inscription.comments">{{inscription.comments}}</textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="statut">Diplôme obtenu/à obtenir</label>
                                            <select id="statut" class="form-control" name="formation[type]"
                                                    @change="inscription.montant=getPrice()"
                                                    v-model="inscription.idDiplome">
                                                <option value="26">Aucun/indéterminé</option>

                                                <optgroup :label="getLabelFromKey(key)" v-for="(meta,key) in getTypesDiplomes()">
                                                    <option
                                                            v-for="diplome in meta"
                                                            :value="diplome.id"
                                                    >{{diplome.grade}}
                                                    </option>
                                                </optgroup>

                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group"
                                             :class="{'has-error': errors.has('inscription[montant]') }">
                                            <label>Montant de l'inscription</label>
                                            <div class="input-group date">
                                                <div class="input-group-addon">
                                                    <i class="fa fa-euro"></i>
                                                </div>
                                                <input class="form-control pull-right"
                                                       v-model="inscription.montant"
                                                       type="text">
                                            </div>
                                            <span v-show="errors.has('inscription[montant]')"
                                                  class="help-block">Montant incorrect</span>
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <label for="">Repassage ?</label>
                                        <div class="form-group">
                                            <label class="radio-inline">
                                                <input type="radio" name="inscription[repassage]" id="radioRepassage"
                                                       value="1"
                                                       v-model="inscription.repassage">
                                                Oui
                                            </label>
                                            <label class="radio-inline">
                                                <input type="radio" name="inscription[repassage]" id="radioRepassage2"
                                                       value="0"
                                                       v-model="inscription.repassage"
                                                >
                                                Non
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="overlay" v-if="loading">
                        <i class="fa fa-refresh fa-spin"></i>
                    </div>
                    <div class="box-footer">
                        <input type="submit"
                               @click.prevent="addInscription()"
                               :disabled="!isFormValid()"
                               value="Ajouter"
                               class="btn btn-primary pull-right"/>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <div class="box box-primary">
                    <div class="box-header with-border">
                        <h3 class="box-title">Listing des inscriptions: {{getFormation.inscriptions.length}} résultat{{getFormation.inscriptions.length>1 ? 's':''}}</h3>
                    </div>
                    <div class="box-body">
                        <!-- Les lignes de facturation découlent de ces montants :
                             les compléter ici évite de les ressaisir une à une -->
                        <div class="row barre-montant-masse">
                            <div class="col-md-3">
                                <div class="input-group input-group-sm">
                                    <input type="text" class="form-control text-right"
                                           v-model="montantEnMasse"
                                           :placeholder="placeholderMontantMasse">
                                    <span class="input-group-addon">€</span>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <label class="case-remplacer">
                                    <input type="checkbox" v-model="remplacerMontants">
                                    Remplacer les montants déjà saisis
                                </label>
                            </div>
                            <div class="col-md-5">
                                <button type="button" class="btn btn-default btn-sm"
                                        :disabled="appliMontantEnCours || !nombreAAppliquer"
                                        @click="appliquerMontantEnMasse()">
                                    <i class="fa fa-euro"></i>
                                    Appliquer à {{ nombreAAppliquer }} inscription(s)
                                </button>
                                <span class="help-block aide-montant">
                                    <span v-if="appliMontantEnCours">{{ progressionMontant }}</span>
                                    <span v-else-if="tarifAutomatiqueDisponible && !montantEnMasse">
                                        Champ vide : le tarif de l'examen est appliqué selon le grade
                                        visé et le repassage.
                                    </span>
                                    <span v-else-if="!montantEnMasse">
                                        Indiquez un montant : cette formation n'a pas de tarif
                                        automatique.
                                    </span>
                                </span>
                            </div>
                        </div>

                        <b-table
                                id="tableListingAllFormations"
                                v-if="getFormation!=null"
                                responsive bordered striped hover
                                :items="getFormation.inscriptions"
                                :fields="columnsListingInscriptions"
                                :current-page="pagination_meta.current_page"
                                :per-page="pagination_meta.per_page"
                                :sort-by.sync="sortBy"
                                :sort-desc.sync="sortDesc"
                                :sort-compare="sortCompareAdvanced"
                                :no-local-sorting="true"
                                :no-sort-reset="true"
                                :empty-text="'Aucun résultat'"
                                :empty-filtered-text="'Aucun résultat'"
                                :busy.sync="isBusy"
                                foot-clone
                                show-empty
                        >
                            <template slot="actions" slot-scope="data">
                                <button v-if="!isEditing(data.item.id)"
                                        @click.prevent="editItem(data.item)"
                                        class="btn btn-default padding2">
                                    <i class="glyphicon glyphicon-pencil"></i>
                                </button>
                                <button v-if="!isEditing(data.item.id)"
                                        @click.prevent="removeInscription(data.item.id)"
                                        class="btn btn-default padding2">
                                    <i class="glyphicon glyphicon-remove"></i>
                                </button>
                                <button v-if="isEditing(data.item.id)"
                                        @click.prevent="validEditing(data.item.id)"
                                        class="btn btn-primary padding2">
                                    <i class="glyphicon glyphicon-ok"></i>
                                </button>
                                <button v-if="isEditing(data.item.id)"
                                        @click.prevent="cancelEditing(data.item.id)"
                                        class="btn btn-danger padding2">
                                    <i class="glyphicon glyphicon-ban-circle"></i>
                                </button>
                            </template>

                            <template slot="membre.nom" slot-scope="data">
                                <router-link
                                        :to="{ name: 'Member', params: { member_id: data.item.membre.id }}">
                                    {{data.item.membre.nom }}
                                </router-link>
                            </template>

                            <template slot="membre.prenom" slot-scope="data">
                                <router-link
                                        :to="{ name: 'Member', params: { member_id: data.item.membre.id }}">
                                    {{data.item.membre.prenom }}
                                </router-link>
                            </template>

                            <template slot="inscription" slot-scope="data">
                                <div v-if="!isEditing(data.item.id)">
                                    {{data.item.inscription==1 ? 'OUI':'NON'}}
                                </div>
                                <div v-if="isEditing(data.item.id)">
                                    <select v-model="getObjectEditable(data.item.id).inscription">
                                        <option value="1">OUI</option>
                                        <option value="0">NON</option>
                                    </select>
                                </div>
                            </template>

                            <template slot="payement" slot-scope="data">
                                <div v-if="!isEditing(data.item.id)">
                                    {{data.item.payement==1 ? 'OUI':'NON'}}
                                </div>
                                <div v-if="isEditing(data.item.id)">
                                    <select v-model="getObjectEditable(data.item.id).payement">
                                        <option value="1">OUI</option>
                                        <option value="0">NON</option>
                                    </select>
                                </div>
                            </template>

                            <template slot="repassage" slot-scope="data">
                                <div v-if="!isEditing(data.item.id)">
                                    {{data.item.repassage==1 ? 'OUI':'NON'}}
                                </div>
                                <div v-if="isEditing(data.item.id)">
                                    <select v-model="getObjectEditable(data.item.id).repassage">
                                        <option value="1">OUI</option>
                                        <option value="0">NON</option>
                                    </select>
                                </div>
                            </template>

                            <template slot="reussite" slot-scope="data">
                                <div v-if="!isEditing(data.item.id)">
                                    {{data.item.reussite==1 ? 'OUI':'NON'}}
                                </div>
                                <div v-if="isEditing(data.item.id)">
                                    <select v-model="getObjectEditable(data.item.id).reussite">
                                        <option value="1">OUI</option>
                                        <option value="0">NON</option>
                                    </select>
                                </div>
                            </template>

                            <template slot="diplome.grade" slot-scope="data">
                                <div v-if="!isEditing(data.item.id)">
                                    {{data.item.diplome.grade}}
                                </div>
                                <div v-if="isEditing(data.item.id)">
                                    <select v-model="data.item.idDiplome">
                                        <option value="26">Aucun/indéterminé</option>
                                        <optgroup :label="getLabelFromKey(key)" v-for="(meta,key) in getTypesDiplomes()">
                                            <option
                                                    v-for="diplome in meta"
                                                    :value="diplome.id"
                                            >{{diplome.grade}}
                                            </option>
                                        </optgroup>
                                    </select>
                                </div>
                            </template>

                            <template slot="dateInscription" slot-scope="data">
                                <div v-if="!isEditing(data.item.id)">
                                    {{formatDate(data.item.dateInscription,"YYYY-MM-DD","DD/MM/YYYY")}}
                                </div>
                                <div v-if="isEditing(data.item.id)">
                                    <masked-input type="text"
                                                  v-model="getObjectEditable(data.item.id).dateInscription"
                                                  v-validate="'required|date_format:DD/MM/YYYY'"
                                                  :mask="[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]"
                                                  :guide="true"
                                                  :keepCharPositions="true"
                                                  :showMask="true"
                                                  class="form-control pull-right datepicker"
                                    >
                                    </masked-input>
                                </div>
                            </template>

                            <template slot="datePayement" slot-scope="data">
                                <div v-if="!isEditing(data.item.id)">
                                    {{formatDate(data.item.datePayement,"YYYY-MM-DD","DD/MM/YYYY")}}
                                </div>
                                <div v-if="isEditing(data.item.id)">
                                    <masked-input type="text"
                                                  v-model="getObjectEditable(data.item.id).datePayement"
                                                  v-validate="'required|date_format:DD/MM/YYYY'"
                                                  :mask="[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]"
                                                  :guide="true"
                                                  :keepCharPositions="true"
                                                  :showMask="true"
                                                  class="form-control pull-right datepicker"
                                    >
                                    </masked-input>
                                </div>
                            </template>

                            <template slot="montant" slot-scope="data">
                                <div v-if="!isEditing(data.item.id)">
                                    {{data.item.montant | idFormat}}€
                                </div>
                                <div v-if="isEditing(data.item.id)">
                                    <div class="input-group date">
                                        <div class="input-group-addon">
                                            <i class="fa fa-euro"></i>
                                        </div>
                                        <input class="form-control pull-right "
                                               v-model="getObjectEditable(data.item.id).montant"
                                               type="text">
                                    </div>
                                </div>
                            </template>
                        </b-table>
                        <b-pagination size="md"
                                      :total-rows="getFormation.inscriptions.length"
                                      v-model="pagination_meta.current_page"
                                      :per-page="pagination_meta.per_page">
                        </b-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import {mapGetters, mapActions} from 'vuex'
    import {ErrorBag} from 'vee-validate';
    import vSelect from '../../Communs/vSelect/index'
    import ListSelectClub from '../../Communs/listeSelectClub'

    require('../../../../node_modules/bootstrap-datepicker/js/bootstrap-datepicker')
    require('../../../../node_modules/bootstrap-datepicker/js/locales/bootstrap-datepicker.fr')

    var _ = require('underscore')
    var moment = require('moment')

    export default {
        props: {},
        data() {
            return {
                pricesDPK: {
                    // "dan1":70,
                    // "dan2":90,
                    // "dan3":120,
                    // "dan4":150,
                    // "dan5":300,
                    // "dan6":350,
                    // "dan7":450,
                    // "dan8":0,
                    // "dan9":0,
                    "dan": 50,
                    "dan_repassage": 50,
                    "keup": 15
                },
                arrayEdits: [],
                arrayInscriptionsEdits: [],
                montantEnMasse: '',
                remplacerMontants: false,
                appliMontantEnCours: false,
                progressionMontant: '',
                sortBy: null,
                sortDesc: null,
                inscription: null,
                listingFormations: [],
                loadingListingFormation: true,
                loading: false,
                isBusy: false,
                disabledBtn: false,
                current_page: 1,
                periodeDu: null,
                periodeAu: null,
                typeSelectedForFilter: 0,
                reset: false,
                previousRequest: false,
                ArrayMembersSearch: [],
                pagination_meta: {
                    current_page: 1,
                    from: 1,
                    last_page: 1,
                    path: "",
                    per_page: 20,
                    to: 1,
                    total: 1
                },
                columnsListingInscriptions: [
                    {
                        label: 'Nom',
                        key: 'membre.nom',
                        sortable: true,
                    },
                    {
                        label: 'Prénom',
                        key: 'membre.prenom',
                        sortable: true,
                    },
                    {
                        label: 'Inscription',
                        key: 'inscription',
                        sortable: true,
                    },
                    {
                        label: "Date d'inscription",
                        key: 'dateInscription',
                        sortable: true,
                    },
                    {
                        label: 'Payement',
                        key: 'datePayement',
                        sortable: true,
                    },
                    {
                        label: 'Montant',
                        key: 'montant',
                        sortable: false,
                    },
                    {
                        label: 'Diplôme',
                        key: 'diplome.grade',
                        sortable: true,
                    },
                    {
                        label: 'Repassage',
                        key: 'repassage',
                        sortable: false,
                    },
                    {
                        label: 'Réussite',
                        key: 'reussite',
                        sortable: false,
                    },
                    {
                        label: 'Commentaires',
                        key: 'comments',
                        sortable: false,
                    },
                    {
                        label: 'Actions',
                        key: 'actions',
                    },
                ]
            }
        },
        computed: {
            ...mapGetters({
                getRoute: 'getRoute',
                getTypesFormation: 'getTypesFormation',
                getFormation: 'getFormation',
            }),
            inscriptionsDeLaFormation: function () {
                return (this.getFormation && this.getFormation.inscriptions) || []
            },
            /** Seuls les examens Dan/Poom/Keup ont un barème connu de l'application. */
            tarifAutomatiqueDisponible: function () {
                return !!(this.getFormation && this.getFormation.type_formation &&
                    this.getFormation.type_formation.id == 1)
            },
            placeholderMontantMasse: function () {
                return this.tarifAutomatiqueDisponible ? 'Montant (vide = tarif)' : 'Montant'
            },
            /** Les inscriptions que le bouton toucherait, dans l'état actuel des options. */
            inscriptionsAAppliquer: function () {
                const remplacer = this.remplacerMontants
                const montantSaisi = this.montantMasseNumerique
                const tarifDisponible = this.tarifAutomatiqueDisponible
                return this.inscriptionsDeLaFormation.filter(function (inscription) {
                    if (!remplacer && parseFloat(inscription.montant) > 0) return false
                    // Sans montant saisi ni barème, il n'y a rien à appliquer
                    return montantSaisi !== null || tarifDisponible
                })
            },
            nombreAAppliquer: function () {
                return this.inscriptionsAAppliquer.length
            },
            montantMasseNumerique: function () {
                const brut = String(this.montantEnMasse || '').replace(',', '.').trim()
                if (!brut) return null
                const nombre = parseFloat(brut)
                return isFinite(nombre) ? nombre : null
            },
        },

        mounted: function () {
            var these = this
            this.resetInscription()
            // this.getTableListingFormation();
            this.$nextTick(function () {
                $('.input-daterange').datepicker({
                    autoclose: true,
                    language: 'fr',
                }).on("changeDate", function (e) {
                    these.periodeDu = $('#datepicker1').val()
                    these.periodeAu = $('#datepicker2').val()
                });
            })
        },
        created() {
        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                // vm.getTableListingFormation();
                // vm.loadStatutsFormations()
            })
        },
        watch: {},
        components: {
            vSelect,
            ListSelectClub,
        },
        methods: {
            ...mapActions({
                setStatusFormation: 'setStatusFormation',
                setFormation: 'setFormation',
            }),
            getPrice: function () {
                if (this.getFormation.type_formation.id == 1) {
                    if (this.inscription.idDiplome <= 9)
                        if (this.repassage)
                            return this.pricesDPK.dan_repassage
                        else
                            return this.pricesDPK.dan
                    else if (this.inscription.idDiplome == 10)
                        return this.pricesDPK.keup
                }
                return 0
            },
            addInscription: function () {
                this.disabledBtn = true;
                this.loading = true
                this.isBusy = true
                let self = this;
                this.$http.post(this.getRoute('Secretariat.formation.storeInscription'), this.constructForm()).then(function (response) {
                    self.$noty.success(this.inscription.idMembre.fullName + " a été inscrit à la formation")
                    this.disabledBtn = false
                    this.setFormation(response.body)
                    this.loading = false
                    this.isBusy = false
                    self.inscription.idMembre = null
                    this.ArrayMembersSearch = []
                }, (response) => {
                    self.$noty.error("Erreur dans l'inscription du membre")
                    this.disabledBtn = false
                    this.loading = false
                    this.isBusy = false
                });
            },
            removeInscription: function (id) {
                let self = this;
                this.isBusy = true
                this.$http.post(this.getRoute('Secretariat.formation.deleteInscription'), {id: id}).then(function (response) {
                    self.$noty.success("L'inscription a bien été supprimée")
                    this.disabledBtn = false
                    this.isBusy = false
                    this.setFormation(response.body)
                    this.arrayEdits = _.reject(this.arrayEdits, function (item) {
                        return item == id;
                    });
                    this.arrayInscriptionsEdits = _.reject(this.arrayInscriptionsEdits, function (item) {
                        return item.id == id;
                    });
                    this.getFormation.inscriptions = _.reject(this.getFormation.inscriptions, function (item) {
                        return item.id == id;
                    });
                }, (response) => {
                    this.isBusy = false
                    self.$noty.error("Erreur dans la modification de l'inscription")
                    this.disabledBtn = false
                });
            },
            validEditing: function (id) {
                // debugger;
                this.isBusy = true
                let inscriptionToUpdate = _.find(this.arrayInscriptionsEdits, function (item) {
                    return item.id == id;
                });
                let self = this;
                this.$http.post(this.getRoute('Secretariat.formation.updateInscription'), this.constructFormInscriptionUpdate(inscriptionToUpdate)).then(function (response) {
                    self.$noty.success("L'inscription a bien été modifiée")
                    this.disabledBtn = false
                    this.isBusy = false

                    this.setFormation(response.body['formation'])
                    this.arrayEdits = _.reject(this.arrayEdits, function (item) {
                        return item == id;
                    });
                    this.arrayInscriptionsEdits = _.reject(this.arrayInscriptionsEdits, function (item) {
                        return item.id == id;
                    });

                    let inscriptionToUpdateInTable = _.find(this.getFormation.inscriptions, function (item) {
                        return item.id == id;
                    });

                    // debugger;
                    _.each(response.body['inscription'], (item, index) => {
                        inscriptionToUpdateInTable[index] = item;
                    })
                }, (response) => {
                    this.isBusy = false
                    self.$noty.error("Erreur dans la modification de l'inscription")
                    this.disabledBtn = false
                });
            },
            cancelEditing: function (id) {
                this.arrayEdits = _.reject(this.arrayEdits, function (item) {
                    return item == id;
                });
                this.arrayInscriptionsEdits = _.reject(this.arrayInscriptionsEdits, function (item) {
                    return item.id == id;
                });
            },
            SearchMembersResponse: function (search, loading) {
                if (search.length <= 2)
                    return;
                let these = this;
                loading(true)
                this.$http.post(this.getRoute("memberSearch"), {q: search}, {
                        before(request) {
                            if (these.previousRequest)
                                these.previousRequest.abort();
                            these.previousRequest = request;
                        }
                    }
                ).then(resp => {
                    loading(false)
                    let idsAlreadyExists = "";
                    this.ArrayMembersSearch = resp.data;
                    this.getFormation.inscriptions.forEach((item) => {
                        this.ArrayMembersSearch = _.reject(this.ArrayMembersSearch, function (item2) {
                            return item.membre.id == item2.id
                        });
                    })
                    this.ArrayMembersSearch = _.where(this.ArrayMembersSearch, {licencie: true}).concat(_.where(this.ArrayMembersSearch, {licencie: false}))
                })
            },

            /**
             * Tarif d'une inscription, selon les mêmes règles que la saisie
             * unitaire (getPrice) : grade visé et repassage pour les examens,
             * rien ailleurs.
             */
            tarifPour: function (inscription) {
                if (!this.tarifAutomatiqueDisponible) return null
                if (inscription.idDiplome <= 9) {
                    return inscription.repassage ? this.pricesDPK.dan_repassage : this.pricesDPK.dan
                }
                if (inscription.idDiplome == 10) return this.pricesDPK.keup
                return null
            },

            /**
             * Complète le montant de plusieurs inscriptions d'un coup : c'est de
             * ces montants que découlent les lignes de facturation, et ils sont
             * souvent laissés vides à l'encodage.
             *
             * Chaque inscription passe par le même chemin qu'une édition
             * manuelle (constructFormInscriptionUpdate + updateInscription),
             * pour ne pas introduire une seconde façon d'enregistrer.
             */
            appliquerMontantEnMasse: function () {
                const cibles = this.inscriptionsAAppliquer.slice()
                if (!cibles.length) return

                const montantSaisi = this.montantMasseNumerique
                const libelle = montantSaisi === null ? 'le tarif' : montantSaisi + ' €'
                if (!confirm('Appliquer ' + libelle + ' à ' + cibles.length +
                    ' inscription(s) ? Les montants seront enregistrés.')) {
                    return
                }

                const self = this
                this.appliMontantEnCours = true
                this.isBusy = true
                let modifiees = 0
                let ignorees = 0

                cibles.reduce(function (chaine, inscription, index) {
                    return chaine.then(function () {
                        self.progressionMontant = 'Enregistrement ' + (index + 1) + '/' + cibles.length
                        const montant = montantSaisi === null ? self.tarifPour(inscription) : montantSaisi
                        // Pas de barème pour cette ligne : on la laisse telle quelle
                        if (montant === null) {
                            ignorees += 1
                            return null
                        }
                        return self.enregistrerMontant(inscription, montant).then(function () {
                            modifiees += 1
                        })
                    })
                }, Promise.resolve()).then(function () {
                    self.appliMontantEnCours = false
                    self.isBusy = false
                    self.progressionMontant = ''
                    self.$noty.success(modifiees + ' montant(s) enregistré(s)' +
                        (ignorees ? ', ' + ignorees + ' sans tarif applicable' : ''))
                }, function () {
                    self.appliMontantEnCours = false
                    self.isBusy = false
                    self.progressionMontant = ''
                    self.$noty.error('Erreur pendant l\'enregistrement des montants')
                })
            },

            /** Une inscription, enregistrée exactement comme le ferait l'édition en ligne. */
            enregistrerMontant: function (inscription, montant) {
                const self = this
                const aEnvoyer = {
                    id: inscription.id,
                    idFormationExamen: inscription.idFormationExamen,
                    idDiplome: inscription.idDiplome,
                    inscription: inscription.inscription,
                    payement: inscription.payement,
                    reussite: inscription.reussite,
                    dateInscription: this.formatDate(inscription.dateInscription, "YYYY-MM-DD", "DD/MM/YYYY"),
                    datePayement: this.formatDate(inscription.datePayement, "YYYY-MM-DD", "DD/MM/YYYY"),
                    montant: montant,
                    repassage: inscription.repassage,
                    comments: inscription.comments,
                }

                return this.$http.post(
                    this.getRoute('Secretariat.formation.updateInscription'),
                    this.constructFormInscriptionUpdate(aEnvoyer)
                ).then(function (response) {
                    // On reflète la réponse dans la ligne affichée, comme validEditing
                    const majour = response.body['inscription']
                    const ligne = _.find(self.getFormation.inscriptions, function (item) {
                        return item.id == inscription.id
                    })
                    if (ligne && majour) {
                        _.each(majour, function (valeur, cle) { ligne[cle] = valeur })
                    }
                })
            },

            getObjectEditable: function (id) {
                return _.find(this.arrayInscriptionsEdits, function (item) {
                    return item.id == id;
                })
            },
            editItem: function (item) {
                this.arrayEdits.push(item.id);
                this.arrayInscriptionsEdits.push({
                    id: item.id,
                    idFormationExamen: item.idFormationExamen,
                    idDiplome: item.idDiplome,
                    inscription: item.inscription,
                    payement: item.payement,
                    reussite: item.reussite,
                    dateInscription: this.formatDate(item.dateInscription, "YYYY-MM-DD", "DD/MM/YYYY"),
                    datePayement: this.formatDate(item.datePayement, "YYYY-MM-DD", "DD/MM/YYYY"),
                    montant: item.montant,
                    repassage: item.repassage,
                    comments: item.comments,
                })
            },
            constructFormInscriptionUpdate: function (inscription) {
                return {
                    id: inscription.id,
                    idFormationExamen: inscription.idFormationExamen,
                    idDiplome: inscription.idDiplome,
                    inscription: inscription.inscription,
                    payement: inscription.payement,
                    reussite: inscription.reussite,
                    dateInscription: this.formatDate(inscription.dateInscription, "DD/MM/YYYY", "YYYY-MM-DD"),
                    datePayement: this.formatDate(inscription.datePayement, "DD/MM/YYYY", "YYYY-MM-DD"),
                    montant: inscription.montant,
                    repassage: inscription.repassage,
                    comments: inscription.comments,
                }
            },
            isEditing: function (id) {
                return _.contains(this.arrayEdits, id)
            },
            flatten: function (obj) {
                var root = {};
                (function tree(obj, index) {
                    var suffix = toString.call(obj) == "[object Array]" ? "]" : "";
                    for (var key in obj) {
                        if (!obj.hasOwnProperty(key)) continue;
                        root[index + key + suffix] = obj[key];
                        if (toString.call(obj[key]) == "[object Array]") tree(obj[key], index + key + suffix + "[");
                        if (toString.call(obj[key]) == "[object Object]") tree(obj[key], index + key + suffix + ".");
                    }
                })(obj, "");
                return root;
            },
            sortCompareAdvanced: function (a, b, key) {
                if (typeof a[key] === 'number' && typeof b[key] === 'number') {
                    // If both compared fields are native numbers
                    return a[key] < b[key] ? -1 : (a[key] > b[key] ? 1 : 0)
                } else {
                    // Stringify the field data and use String.localeCompare
                    return (this.flatten(a)[key]).toString().localeCompare((this.flatten(b)[key]).toString(), undefined, {
                        numeric: true
                    })
                }
            },
            isFormValid: function () {
                return this.inscription.idMembre != null
                    && this.inscription.idDiplome != null
                    && this.inscription.idDiplome != 0
                    && this.inscription.montant != null
            },
            resetInscription: function () {
                this.inscription = {
                    idFormationExamen: 0,
                    idMembre: null,
                    inscription: 1,
                    payement: 1,
                    reussite: 1,
                    idDiplome: 26,
                    dateInscription: moment().format('DD/MM/YYYY'),
                    datePayement: moment().format('DD/MM/YYYY'),
                    montant: 0,
                    repassage: 0,
                    comments: "",
                }
            },
            constructForm: function () {
                return {
                    idFormationExamen: this.getFormation.id,
                    idMembre: this.inscription.idMembre.id,
                    inscription: this.inscription.inscription,
                    payement: this.inscription.payement,
                    reussite: this.inscription.reussite,
                    idDiplome: this.inscription.idDiplome,
                    dateInscription: this.formatDate(this.inscription.dateInscription, "DD/MM/YYYY", "YYYY-MM-DD"),
                    datePayement: this.formatDate(this.inscription.datePayement, "DD/MM/YYYY", "YYYY-MM-DD"),
                    montant: this.inscription.montant,
                    repassage: this.inscription.repassage,
                    comments: this.inscription.comments
                }
            },
            getTypesDiplomes: function () {
                let self = this
                // debugger;
                let result = _.groupBy(this.getFormation.diplomes, function (item) {
                    return item.desc;
                });
                // debugger;
                return result;
            },
            getLabelFromKey: function (key) {
                switch (key) {
                    case 'noire':
                        return 'Dan';
                        break;

                    default:
                        return key.charAt(0).toUpperCase() + key.slice(1);
                        break;
                }
            },
            currentYear: function () {
                return moment().year();
            },
            console: function (event) {
                console.log(event);
            },
            formatDate: function (value, fmtIn = 'YYYY-MM-DD hh:mm:ss', fmtOut = 'DD/MM/YYYY HH:mm') {
                if (value == null) return ''
                return moment(value, fmtIn).format(fmtOut)
            },
        },
        filters: {
            idFormat: function (value) {
                return new Intl.NumberFormat("de-DE").format(value)
            }
        },
    }
</script>


<style scoped>
    .barre-montant-masse {
        margin-bottom: 12px;
    }

    .case-remplacer {
        font-weight: 400;
        line-height: 30px;
        margin-bottom: 0;
    }

    .aide-montant {
        display: inline-block;
        margin-left: 10px;
        margin-bottom: 0;
        font-size: 11px;
        vertical-align: middle;
        max-width: 420px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Secretariat/Formation/InscriptionsResultats.vue